"use strict";

exports.__esModule = true;
exports.StyledTable = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styles = require("../TBody/styles");

var _styles2 = require("../TR/styles");

var _styledSystem = require("styled-system");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StyledTable = _styledComponents.default.table`
    border-collapse: collapse;
    width: 100%;
    margin: 30px 0;
    border: 1px solid ${({
  theme
}) => theme.colors.table.border};
    box-sizing: border-box;
    font-size: ${({
  theme
}) => theme.fontSizes[3]};
    font-weight: ${({
  theme
}) => theme.fontWeights.light};
    color: ${({
  theme
}) => theme.colors.table.body.text};
    background-color: ${({
  theme
}) => theme.colors.table.body.background};
    text-align: left;

    ${({
  theme,
  striped
}) => striped && (0, _styledComponents.css)`
            tbody {
                tr {
                    &:nth-child(even) {
                        background-color: ${theme.colors.table.body.stripedRow};
                    }
                }
            }
        `}

    ${_styledSystem.space}
    ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
    ${_styledSystem.border}
    ${_styledSystem.position}
`;
exports.StyledTable = StyledTable;